"use client";

import CatalogCard from "@/components/entities/catalog-card";
import S from "./index.module.scss";
import { useCatalogData } from "../../hooks/useCatalogData";

const CatalogList = () => {
  const { catalog } = useCatalogData();

  if (!catalog || catalog.length === 0) return null;

  return (
    <div className={S.cards}>
      {catalog.map((item, index) => (
        <CatalogCard key={`${item.name}-${index}`} item={item} variant="catalog" />
      ))}
    </div>
  );
};

export default CatalogList;
